@for (toast of toasts$ | async; track $index) {
  <id-alert
    class="ids-mb-8"
    [headline]="toast.title || ''"
    [ribbon]="toast.title ? false : true"
    live="polite"
    [dismissible]="true"
    (onClosed)="dismissToast(toast)"
    swipe
    (swipes)="swipeAction($event, toast)"
    mouseHover
    (hoverState)="handleHover($event, toast)"
    [class.destroy]="toast.destroy"
    [type]="getType(toast)">
    @if (isSingle(toast.message)) {
      <p>
        {{ toast.message }}
      </p>
    }

    @if (!isSingle(toast.message)) {
      @for (msg of toast.message; track $index) {
        <ul>
          <li>
            <p>{{ msg }}</p>
          </li>
        </ul>
      }
    }
  </id-alert>
}
